import { render, staticRenderFns } from "./SenetAlacakForm.vue?vue&type=template&id=7ad31125"
import script from "./SenetAlacakForm.vue?vue&type=script&lang=ts"
export * from "./SenetAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports